<div class="ir" *ngIf="review" role="region" aria-label="Imported RFQ review">

  <!-- Headline: what the import understood, in one line. -->
  <div class="ir__head">
    <div class="ir__icon"><mat-icon>fact_check</mat-icon></div>
    <div class="ir__headtext">
      <div class="ir__title">We read this RFQ before importing it</div>
      <div class="ir__sub">{{ review.summary }}</div>
    </div>
    <div class="ir__badge ir__badge--stop" *ngIf="!review.canImport">
      <mat-icon>error</mat-icon>
      <span>Needs attention</span>
    </div>
  </div>

  <!-- Counters. Each is a decision the buyer may want to act on. -->
  <div class="ir__stats">
    <div class="ir-stat" *ngIf="review.totals?.spareParts" style="animation-delay:40ms">
      <span class="ir-stat__n">{{ review.totals.spareParts }}</span>
      <span class="ir-stat__l">{{ review.totals.spareParts === 1 ? 'spare part' : 'spare parts' }}</span>
    </div>
    <div class="ir-stat" *ngIf="review.totals?.consumables" style="animation-delay:80ms">
      <span class="ir-stat__n">{{ review.totals.consumables }}</span>
      <span class="ir-stat__l">{{ review.totals.consumables === 1 ? 'consumable' : 'consumables' }}</span>
    </div>
    <div class="ir-stat ir-stat--known" *ngIf="review.totals?.alreadyOnMps" style="animation-delay:120ms">
      <span class="ir-stat__n">{{ review.totals.alreadyOnMps }}</span>
      <span class="ir-stat__l">already on MPS</span>
    </div>
    <div class="ir-stat ir-stat--new" *ngIf="review.totals?.newToMps" style="animation-delay:160ms">
      <span class="ir-stat__n">{{ review.totals.newToMps }}</span>
      <span class="ir-stat__l">new to MPS</span>
    </div>
    <div class="ir-stat ir-stat--check" *ngIf="review.totals?.needsReview" style="animation-delay:200ms">
      <span class="ir-stat__n">{{ review.totals.needsReview }}</span>
      <span class="ir-stat__l">need a check</span>
    </div>
    <div class="ir-stat ir-stat--skip" *ngIf="review.totals?.unreadable" style="animation-delay:240ms">
      <span class="ir-stat__n">{{ review.totals.unreadable }}</span>
      <span class="ir-stat__l">skipped</span>
    </div>
  </div>

  <!-- Privacy: the single most important thing to say up front. -->
  <div class="ir__privacy">
    <mat-icon>lock</mat-icon>
    <span>
      Everything here stays <b>private to you</b> until you submit this RFQ.
      New items are held in your own catalogue, not published to the platform.
    </span>
  </div>

  <!-- Currency: the platform trades in EUR and USD only. -->
  <div class="ir__row" *ngIf="review.currency?.value"
       [class.ir__row--warn]="review.currency?.accepted === false">
    <mat-icon>payments</mat-icon>
    <span><b>Currency</b> — {{ review.currency.note }}</span>
  </div>

  <!-- Equipment named on the document. -->
  <div class="ir__row" *ngIf="review.equipment"
       [class.ir__row--warn]="review.equipment.needsReview">
    <mat-icon>precision_manufacturing</mat-icon>
    <span>
      <b>Equipment</b> — {{ review.equipment.name }}
      <ng-container *ngIf="review.equipment.maker"> &middot; {{ review.equipment.maker }}</ng-container>
      <ng-container *ngIf="review.equipment.serialNo"> &middot; serial {{ review.equipment.serialNo }}</ng-container>
    </span>
  </div>

  <!-- Suppliers named on the document. -->
  <div class="ir__row" *ngFor="let s of review.suppliers"
       [class.ir__row--warn]="s.state === 'NOT_ON_MPS'">
    <mat-icon>storefront</mat-icon>
    <span><b>{{ s.name }}</b> — {{ s.note }}</span>
  </div>

  <!-- Anything that would stop the import. -->
  <div class="ir__row ir__row--stop" *ngFor="let b of review.blocking">
    <mat-icon>report</mat-icon>
    <span>{{ b }}</span>
  </div>

  <!-- Line detail, folded away until asked for. -->
  <button type="button" class="ir__toggle" (click)="showLines = !showLines"
          *ngIf="lines.length">
    <mat-icon>{{ showLines ? 'expand_less' : 'expand_more' }}</mat-icon>
    <span>{{ toggleLabel }}</span>
  </button>

  <div class="ir__lines" *ngIf="showLines">
    <div class="ir-line" *ngFor="let l of lines; let i = index"
         [style.animation-delay]="(i * 35) + 'ms'"
         [class.ir-line--muted]="l.status === 'UNREADABLE'">
      <span class="ir-line__no">{{ l.rowNo }}</span>
      <span class="ir-chip" [ngClass]="chipClass(l)">{{ chipLabel(l) }}</span>
      <span class="ir-line__desc">{{ l.description }}</span>
      <span class="ir-line__part" *ngIf="l.partNumber">
        {{ l.partNumber }}
        <em *ngIf="l.partNumberRecovered" matTooltip="Read out of the description, where this platform writes it">recovered</em>
      </span>
      <span class="ir-line__state" *ngIf="l.catalogue?.state === 'ALREADY_ON_MPS'">on MPS</span>
      <span class="ir-line__state ir-line__state--new" *ngIf="l.catalogue?.state === 'NEW_TO_MPS'">new</span>
      <span class="ir-line__why" *ngIf="l.reason">{{ l.reason }}</span>
    </div>
  </div>

  <div class="ir__foot">
    <mat-icon>drafts</mat-icon>
    <span>This RFQ opens as a <b>Draft</b>. Nothing goes to your suppliers until you submit it.</span>
  </div>
</div>
